import { render, staticRenderFns } from "./tags_edit.vue?vue&type=template&id=3ff9d23a&"
import script from "./tags_edit.vue?vue&type=script&lang=js&"
export * from "./tags_edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports